import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("新規スタッフの追加")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_4 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "leading-7 text-sm font-medium text-gray-500" }, "パスワード", -1)
const _hoisted_6 = { class: "flex-grow bg-secondary-100 rounded-md border text-base outline-none text-gray-600 py-1 px-3 leading-8 whitespace-nowrap overflow-hidden" }
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "w-full mx-auto text-center text-sm mt-2 font-medium text-gray-600" }, " ※ 新規で登録したスタッフの方はこのパスワードでログイン後、自身でパスワードを再設定する必要があります。 ", -1)
const _hoisted_8 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_9 = {
  key: 0,
  class: "w-3/4 mx-auto mb-6"
}
const _hoisted_10 = { class: "w-3/4 mx-auto text-center text-sm text-gray-500" }
const _hoisted_11 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_12 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_13 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_14 = { class: "p-4 bg-primary-100 rounded-md" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = {
  key: 0,
  id: "password-login-disabled-add",
  type: "checkbox",
  name: "password-login-disabled-add",
  checked: "",
  disabled: "",
  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("label", {
  for: "password-login-disabled-add",
  class: "pl-2 cursor-pointer"
}, " パスワードログインを無効にする ", -1)
const _hoisted_18 = {
  key: 0,
  class: "mt-2 text-xs text-gray-500"
}
const _hoisted_19 = {
  key: 1,
  class: "mt-2 text-xs text-gray-500"
}
const _hoisted_20 = { class: "flex gap-2" }
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" CSVフォーマット ")
const _hoisted_22 = { for: "csv" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" CSVでスタッフを追加 ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" スタッフを登録 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_select_box = _resolveComponent("m-select-box")
  const _component_m_multi_select_box = _resolveComponent("m-multi-select-box")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_m_base_modal = _resolveComponent("m-base-modal")

  return (_openBlock(), _createBlock(_component_m_base_modal, { onClose: _ctx.close }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    body: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "スタッフ名",
          name: "name",
          type: "text",
          placeholder: "スタッフ名を入力",
          value: _ctx.name,
          invalid: !_ctx.validName,
          "invalid-message": "スタッフ名は入力必須です",
          entered: _ctx.enteredName,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.name = $event)),
          onEnter: _cache[2] || (_cache[2] = ($event: any) => (_ctx.enteredName = true))
        }, null, 8, ["value", "invalid", "entered"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_m_text_field, {
          label: "メールアドレス (重複不可)",
          name: "email",
          type: "email",
          placeholder: "example@mingaku.net",
          value: _ctx.email,
          invalid: !_ctx.validEmail,
          "invalid-message": "正しいメールアドレスを入力してください",
          entered: _ctx.enteredEmail,
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.email = $event)),
          onEnter: _cache[4] || (_cache[4] = ($event: any) => (_ctx.enteredEmail = true))
        }, null, 8, ["value", "invalid", "entered"])
      ]),
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, _toDisplayString(_ctx.password), 1),
        _hoisted_7
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode(_component_m_select_box, {
          label: "権限",
          name: "authority",
          placeholder: "権限を選択",
          options: _ctx.authorityTexts,
          value: _ctx.authorityText,
          onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.authorityText = $event))
        }, null, 8, ["options", "value"])
      ]),
      (
          _ctx.authority == 'general' ||
          _ctx.authority == 'employee' ||
          _ctx.authority == 'supervisor'
        )
        ? (_openBlock(), _createBlock("div", _hoisted_9, [
            _createVNode(_component_m_multi_select_box, {
              label: "確認権限を持つ教室一覧",
              name: "classrooms",
              placeholder: _ctx.classroomsPlaceholder,
              options: _ctx.classrooms,
              values: _ctx.selectClassrooms,
              "text-key": "data.name",
              "primary-key": "ref.id",
              onChange: _ctx.changeClassroom
            }, null, 8, ["placeholder", "options", "values", "onChange"])
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_10, _toDisplayString(`※${
            _ctx.isSchool ? "「管理職」「ICT担当者」" : "「オーナー」「管理者」"
          }権限を持つスタッフは全ての教室の確認権限を持ちます`), 1),
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_m_text_field, {
          label: "Googleアカウント",
          name: "gmail",
          placeholder: "スタッフのGmailを入力してください（任意）",
          value: _ctx.googleAccountEmail,
          invalid: !_ctx.validGoogleAccountEmail,
          "invalid-message": "メールアドレスが正しくありません",
          entered: "",
          onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.googleAccountEmail = $event))
        }, null, 8, ["value", "invalid"])
      ]),
      _createVNode("div", _hoisted_12, [
        _createVNode(_component_m_text_field, {
          label: "Microsoftアカウント",
          name: "microsoftEmail",
          placeholder: "スタッフのMicrosoftメールを入力してください（任意）",
          value: _ctx.microSoftAccountEmail,
          invalid: !_ctx.validMicroSoftAccountEmail,
          "invalid-message": "メールアドレスが正しくありません",
          entered: "",
          onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.microSoftAccountEmail = $event))
        }, null, 8, ["value", "invalid"])
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, [
          _createVNode("div", _hoisted_15, [
            (_ctx.passwordLoginLockedBySchool)
              ? (_openBlock(), _createBlock("input", _hoisted_16))
              : _withDirectives((_openBlock(), _createBlock("input", {
                  key: 1,
                  id: "password-login-disabled-add",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.passwordLoginDisabled = $event)),
                  type: "checkbox",
                  name: "password-login-disabled-add",
                  class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                }, null, 512)), [
                  [_vModelCheckbox, _ctx.passwordLoginDisabled]
                ]),
            _hoisted_17
          ]),
          (_ctx.passwordLoginLockedBySchool)
            ? (_openBlock(), _createBlock("p", _hoisted_18, _toDisplayString(`このスクールでは${
                _ctx.isSchool ? "「管理職」「ICT担当者」" : "「オーナー」「管理者」"
              }以外のスタッフはパスワードログインが無効です。Google / Microsoft アカウントでのログインのみ利用できます`), 1))
            : (_openBlock(), _createBlock("p", _hoisted_19, " 有効にすると Google / Microsoft アカウントでのログインのみ利用できます "))
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createVNode("div", _hoisted_20, [
        _createVNode(_component_m_button, {
          color: "gray-500",
          size: "sm",
          text: "",
          external: "",
          onClick: _ctx.downloadCsvTemplate
        }, {
          default: _withCtx(() => [
            _createVNode(_component_m_icon, {
              type: "external",
              class: "mr-2"
            }),
            _hoisted_21
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode("label", _hoisted_22, [
          _createVNode(_component_m_button, {
            color: "secondary-500",
            "hover-color": "secondary-600",
            outline: "",
            "is-div": ""
          }, {
            default: _withCtx(() => [
              _hoisted_23
            ]),
            _: 1
          }),
          _createVNode("input", {
            id: "csv",
            type: "file",
            accept: ".csv",
            name: "csv",
            class: "hidden",
            onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.handleCsvRegistration && _ctx.handleCsvRegistration(...args)))
          }, null, 32)
        ]),
        _createVNode(_component_m_button, {
          color: "primary-500",
          "hover-color": "primary-600",
          disabled: !_ctx.validData && _ctx.allEntered,
          onClick: _ctx.register
        }, {
          default: _withCtx(() => [
            _hoisted_24
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
}